import { mutatorAction } from "satcheljs";
import getStore from "../store/store";

const setUnseenCountMutator: (value: boolean) => void = mutatorAction("SET_UNSEEN_COUNT", function setUnseenCount(value: boolean): void {
    getStore().areMessagesUnseen = value;
});
export default setUnseenCountMutator;
